module.exports = __webpack_public_path__ + "static/media/feta_meli_thumb.ffdb33f1.jpg";